import { PropsWithChildren } from "react";
import { RouteConfig } from "./routeTypes";

type Props = PropsWithChildren & {
  config: RouteConfig;
};

export const ProtectedRouteWrapper: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};
